/*  MUI  */
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    FormControl,
    FormControlLabel,
    Grid,
    Typography
} from '@mui/material';

/*  Shared  */
import { CopyInternalUseId } from 'application/Shared/Components/CopyInternalUseId';
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';
import { Notify } from 'application/Shared/Helpers';
import { TenantSetting } from 'application/Shared/Requests';
import { debug } from 'application/Shared/Utils';
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';

/*  NPM  */
import { withTranslation } from 'react-i18next';
import { withRouter } from 'router/withRouter';

class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            originalUserTrackingVal: false,
            settings: {
                enableAuvikSupportAccess: true,
                qbrToCBR: false,
                userTracking: true
            }
        };

        const clientId = props?.match?.params?.clientId;
        /* requests */
        this.TenantSetting = new TenantSetting(clientId);
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const { settings } = this.state;
        const updatedSetting = { ...settings };

        // TODO: Fix - SAAS-994
        // eslint-disable-next-line no-restricted-syntax
        for (const key in settings) {
            if (key) {
                // TODO: Fix - SAAS-994
                // eslint-disable-next-line no-await-in-loop
                const [err, value] = await this.TenantSetting.getValue(key);

                // We can't just check value here, b/c some settings are set as `false` and it won't properly pick up the setting.
                if (!err) {
                    updatedSetting[key] = value;
                    if (key === 'userTracking') {
                        this.setState({ originalUserTrackingVal: value });
                    }
                }
            }
        }

        if (!this.unmount) {
            this.setState({ loaded: true, settings: updatedSetting });
        }
    };

    unload = () => {
        this.unmount = true;
        this.TenantSetting.cancel();
    };

    save = async () => {
        const { t, match } = this.props;
        const { partnerId } = match.params;

        const { originalUserTrackingVal, settings } = this.state;
        const { enableAuvikSupportAccess, qbrToCBR, userTracking } = settings;
        const err = t('TenantSettings.unableToSave');

        try {
            await axios.post('/tenantSetting', {
                key: 'qbrToCBR',
                value: qbrToCBR
            });
            await axios.post('/tenantSetting', {
                key: 'enableAuvikSupportAccess',
                value: enableAuvikSupportAccess
            });
            if (originalUserTrackingVal !== settings.userTracking) {
                await axios.post('/tenantSetting', {
                    key: 'userTracking',
                    value: userTracking
                });
                // refresh page to properly initialize or remove heap and pendo if this setting is changed
                window.location.reload();
            }

            this.props.setTenantIsStale(partnerId);
        } catch (e) {
            debug.e(err, e);
            Notify.e(err);
            return;
        }

        Notify.s(t('TenantSettings.saved'));
    };

    renderSettings = () => {
        const { t } = this.props;
        const { settings } = this.state;
        return (
            <>
                <FormControl fullWidth style={{ marginTop: '12px' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                data-testid="hubSettingsSettingsQbrBtn"
                                checked={settings.qbrToCBR}
                                onChange={(e) =>
                                    this.setState({
                                        settings: {
                                            ...settings,
                                            qbrToCBR: e.target.checked
                                        }
                                    })
                                }
                                style={{
                                    paddingBottom: 0,
                                    paddingTop: 0
                                }}
                            />
                        }
                        label={t('TenantSettings.qbrToCBR')}
                        style={{
                            alignItems: 'flex-start',
                            display: 'flex'
                        }}
                    />
                </FormControl>
                <FormControl fullWidth style={{ marginTop: '12px' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                data-testid="hubSettingsSettingsTrackingBtn"
                                checked={settings.userTracking}
                                onChange={(e) =>
                                    this.setState({
                                        settings: {
                                            ...settings,
                                            userTracking: e.target.checked
                                        }
                                    })
                                }
                                style={{
                                    paddingBottom: 0,
                                    paddingTop: 0
                                }}
                            />
                        }
                        label={
                            <Box display="inline-flex" alignItems="center">
                                {t('TenantSettings.user_tracking')}
                                <TooltipQ
                                    text={t('Tooltips.user_tracking_warning')}
                                    size={FontSizes[1]}
                                />
                            </Box>
                        }
                        style={{
                            alignItems: 'flex-start',
                            display: 'flex'
                        }}
                    />
                </FormControl>
                <FormControl fullWidth style={{ marginTop: '12px' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                data-testid="hubSettingsSettingsSupportBtn"
                                checked={settings.enableAuvikSupportAccess}
                                onChange={(e) =>
                                    this.setState({
                                        settings: {
                                            ...settings,
                                            enableAuvikSupportAccess:
                                                e.target.checked
                                        }
                                    })
                                }
                                style={{
                                    paddingBottom: 0,
                                    paddingTop: 0
                                }}
                            />
                        }
                        label={
                            <Box display="inline-flex" alignItems="center">
                                {t('TenantSettings.enableAuvikSupportAccess')}
                                <TooltipQ
                                    text={t(
                                        'Tooltips.enableAuvikSupportAccessWarning'
                                    )}
                                    size={FontSizes[1]}
                                />
                            </Box>
                        }
                        style={{
                            alignItems: 'flex-start',
                            display: 'flex'
                        }}
                    />
                </FormControl>
            </>
        );
    };

    render() {
        const { t, match } = this.props;
        const { partnerId } = match.params;

        const { loaded } = this.state;

        if (!loaded) {
            <Box display="flex" justifyContent="center" width="100%">
                <CircularProgress />
            </Box>;
        }

        return (
            <Grid container spacing={0} data-testid="hubSettingsSettingsPage">
                <Grid item xs={12} p={1}>
                    <Box mb="8px">
                        <Typography variant="h5">
                            {t('HubSettings.tenantDetails')}
                        </Typography>
                    </Box>
                    <CopyInternalUseId
                        title={t('ClientSettings.tenantReferenceId')}
                        value={partnerId}
                    />
                </Grid>
                <Grid item xs={12}>
                    <hr />
                </Grid>
                <Grid item xs={12} p={1}>
                    <Typography variant="h5">
                        {t('HubSettings.partnerTenantConfigurationSettings')}
                    </Typography>
                    {this.renderSettings()}
                </Grid>
                <Grid item xs={12}>
                    <hr />
                    <Box display="flex" justifyContent="flex-end" mb="8px">
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => this.save()}
                            data-testid="hubSettingsSettingsSaveBtn"
                        >
                            {t('Common.save_settings')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        );
    }
}
export default withRouter(withTranslation()(Settings));
